// extracted by mini-css-extract-plugin
module.exports = {"row":"form_row_2XSKX","card":"form_card_g6NjD","avatar":"form_avatar_3d4bA"};